import React, { useEffect } from 'react';
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';
import bg_pricing from '../../assets/img/landingPage/fondo.png'
import ReactGA from 'react-ga4'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';


import logo_lang from '../../assets/img/logos/AVAP_Lenguaje_white.svg'
import logo_vs from '../../assets/img/logos/AVAP_VS_white.svg'
import logo_gateway from '../../assets/img/logos/AVAP_Gateway_white.svg'



import icn_cli from '../../assets/img/logos/icono_Cli.svg'
import icn_interpreter from '../../assets/img/logos/icon_avap.svg'
import icn_api_extensions from '../../assets/img/logos/icono_DS.svg'
import icn_dev_studio from '../../assets/img/logos/icono_DS.svg'
import icn_virtual_server from '../../assets/img/logos/icono_VS.svg'
import icn_gateway_advanced from '../../assets/img/logos/icono_Gateway.svg'
import icn_developerTk from '../../assets/img/logos/icn_AVAP_DeveloperToolKit.svg'

import icn_link from '../../assets/img/ui_icons/linkChain.svg'

import softtek from '../../assets/img/logosoftek.svg'

import icn_windows from '../../assets/img/ui_icons/windows.svg'
import icn_macos from '../../assets/img/ui_icons/mac.svg'
import icn_linux from '../../assets/img/ui_icons/linux.svg'
import icn_kubernetes from '../../assets/img/ui_icons/docker.svg'

import icn_doc from '../../assets/img/ui_icons/icn_docs.svg'
import icn_download from '../../assets/img/ui_icons/icn_dowlnoad.svg'


import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

const BASE_URL = 'https://static.avapframework.com/static_images/downloads/staging';

// Datos de las tarjetas
const downloadCards = [
    {
        "title": "AVAP CLI (Command Line Interface)",
        "icon": icn_cli,
        "description": "AVAP CLI is a powerful tool designed to streamline API development and management. It offers developers a seamless way to interact with AVAP Framework, automate tasks, deploy APIs, and manage workflows efficiently.",
        "platforms": {
            "Windows": {
                "download_link": `${BASE_URL}/windows/windows-avapcli.zip`
            },
            "MacOs_intel": {
                "download_link": `${BASE_URL}/macos_intel/macos_intel-avapcli.zip`
            },
            "MacOs_arm64": {
                "download_link": `${BASE_URL}/macos_arm64/macos_arm64-avapcli.zip`
            },
            "Linux": {
                "download_link": `${BASE_URL}/linux/linux-avapcli.zip`
            }
        }
    },
    {
        "title": "AVAP API Extensions",
        "icon": icn_api_extensions,
        "description": "AVAP language and development tools are available and can be installed directly from the Microsoft Visual Code Marketplace.",
        "link": {
            "Microsoft Visual Code Marketplace": {
                "download_link": "https://marketplace.visualstudio.com/search?term=avap&target=VSCode&category=All%20categories&sortBy=Relevance",
                "icon": icn_windows
            }
        }
    },
    {
        "title": "AVAP Dev Studio",
        "icon": icn_dev_studio,
        "description": "AVAP own IDE software application that provides full AVAP technology to code, interpret, control versions, manage projects and publish APIs. Take full advantage of AVAP Framework.",
        "status": "Coming Soon"
    },
    {
        "title": "AVAP Interpreter & Language Server",
        "icon": icn_interpreter,
        "description": "AVAP Interpreter executes instructions written in an AVAP Language Server without the need to compile the source code into machine code beforehand.",
        "platforms": {
            "Windows": {
                "download_link": `${BASE_URL}/windows/windows-AVAP.zip`
            },
            "MacOs_intel": {
                "download_link": `${BASE_URL}/macos_intel/macos_intel-AVAP.zip`
            },
            "MacOs_arm64": {
                "download_link": `${BASE_URL}/macos_arm64/macos_arm64-AVAP.zip`
            },
            "Linux": {
                "download_link": `${BASE_URL}/linux/linux-AVAP.zip`
            }
        }
    },
    {
        "title": "AVAP Virtual Server",
        "icon": icn_virtual_server,
        "description": "Take control of the complete lifecycle of your APIs with AVAP Virtual Server (AVS) our own API management platform. Your projects will be executed more efficiently thanks to integrated services as API manager and AVAP Gateway Advanced.",
        "platforms": {
            "Windows": {
                "download_link": `${BASE_URL}/windows/windows-AVS.zip`
            },
            "MacOs_intel": {
                "download_link": `${BASE_URL}/macos_intel/macos_intel-AVS.zip`
            },
            "MacOs_arm64": {
                "download_link": `${BASE_URL}/macos_arm64/macos_arm64-AVS.zip`
            },
            "Linux": {
                "download_link": `${BASE_URL}/linux/linux-AVS.zip`
            }
        }
    },
    {
        "title": "AVAP Gateway Advanced",
        "icon": icn_gateway_advanced,
        "description": "An AVAP API management service that functions as an intermediary for requests from clients seeking resources from one or more backend services.",
        "platforms": {
            "Kubernetes deployment": {
                "download_link": `${BASE_URL}/deployment.yaml`
            }
        }
    },
    {
        "title": "AVAP Developer Toolkit",
        "icon": icn_developerTk,
        "description": "AVAP Developer Toolkit is a comprehensive suite of tools and resources designed to enhance the development experience within the AVAP ecosystem.",
        "platforms": {
            "Windows": {
                "download_link": `${BASE_URL}/windows/windows-tk.zip`
            },
            "MacOs_intel": {
                "download_link": `${BASE_URL}/macos_intel/macos_intel-tk.zip`
            },
            "MacOs_arm64": {
                "download_link": `${BASE_URL}/macos_arm64/macos_arm64-tk.zip`
            },
            "Linux": {
                "download_link": `${BASE_URL}/linux/linux-tk.zip`
            }
        }
    },
];

// Define platform icons mapping
const platformIcons: Record<string, string> = {
    "Windows": icn_windows,
    "MacOs_intel": icn_macos,
    "MacOs_arm64": icn_macos, // Assuming same icon for both Mac versions
    "Linux": icn_linux,
    "Kubernetes deployment": icn_kubernetes
};

// Define platform alt text mapping
const platformAltText: Record<string, string> = {
    "Kubernetes deployment": "Logo of Kubernetes."
    // Add other specific alt texts if needed
};

interface Platform {
    download_link: string;
}

interface Link {
    download_link: string;
    icon: string;
}

const DownloadCard = ({ title, icon, description, platforms, link, status, platformIcons }: {
    title: string;
    icon: string;
    description: string;
    platforms?: Record<string, Platform>;
    link?: Record<string, Link>;
    status?: string;
    platformIcons: Record<string, string>;
}) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [selectedPlatform, setSelectedPlatform] = React.useState<string>('');
    const [downloadLink, setDownloadLink] = React.useState<string>('');
    const dropdownRef = React.useRef<HTMLDivElement>(null);

    // Seleccionar el primer item por defecto
    React.useEffect(() => {
        if (platforms) {
            const firstPlatform = Object.keys(platforms)[0];
            setSelectedPlatform(firstPlatform);
            setDownloadLink(platforms[firstPlatform].download_link);
        }
    }, [platforms]);

    // Cerrar dropdown al hacer click fuera
    React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="col-lg-4 col-md-6 mb-4">
            <div className="card-download h-100">
                <div className="card-download-header">
                    <img src={icon} alt={`Logo ${title}`} className="card-icon" />
                    <h3>{title}</h3>
                </div>
                <div className="card-download-body">
                    <p>{description}</p>
                </div>
                <div className="card-download-footer">
                    {status ? (
                        <div className="coming-soon-badge" aria-label="Button labeled 'Coming Soon'.">{status}</div>
                    ) : platforms ? (
                        <div className="download-platforms">
                            <div className="platform-selector">
                                <div className="custom-dropdown" ref={dropdownRef}>
                                    <button
                                        className="dropdown-toggle"
                                        onClick={() => setIsOpen(!isOpen)}
                                        aria-label={title === "AVAP CLI (Command Line Interface)" ? "Button with operating system for the user to choose the correct OS." : `Select operating system for ${title}`}
                                    >
                                        {selectedPlatform && platformIcons[selectedPlatform] && (
                                            <img
                                                src={platformIcons[selectedPlatform]}
                                                alt={platformAltText[selectedPlatform] || `Logo ${selectedPlatform}`}
                                                className="platform-icon-selected" style={{ marginRight: '8px', height: '16px', verticalAlign: 'middle' }}
                                            />
                                        )}
                                        <span>{selectedPlatform || 'Select Platform'}</span>
                                    </button>
                                    {isOpen && (
                                        <div className="dropdown-menu">
                                            {Object.entries(platforms).map(([platform, { download_link }]) => (
                                                <div
                                                    key={platform}
                                                    className="dropdown-item"
                                                    onClick={() => {
                                                        setSelectedPlatform(platform);
                                                        setDownloadLink(download_link);
                                                        setIsOpen(false);
                                                    }}
                                                    role="option"
                                                    aria-selected={selectedPlatform === platform}
                                                >
                                                    {platformIcons[platform] && (
                                                        <img
                                                            src={platformIcons[platform]}
                                                            alt={platformAltText[platform] || `Logo ${platform}`}
                                                            className="platform-icon-dropdown" style={{ marginRight: '8px', height: '16px', verticalAlign: 'middle' }} />
                                                    )}
                                                    {platform}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                <div className="action-buttons">
                                    <a
                                        href="#"
                                        className="download-button icon-button"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        title="Documentation"
                                        aria-label={`Button with document icon directing users to ${title} documentation.`}
                                        style={{ marginRight: '8px' }}
                                    >
                                        <img src={icn_doc} alt="Documentation Icon" className="button-icon" />
                                    </a>
                                    <a
                                        href={downloadLink}
                                        className="download-button icon-button"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        title={`Download for ${selectedPlatform}`}
                                        aria-label={`Button with download icon initiates the download of ${title}`}
                                    >
                                        <img src={icn_download} alt="Download Icon" className="button-icon" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    ) : link && (
                        <div className="download-platforms">
                            {Object.entries(link).map(([linkLabel, linkData]) => (
                                <div key={linkLabel} className="link-container" style={{ display: 'flex', alignItems: 'center' }}>
                                    <div className="container-link-platform">
                                        <img src={linkData.icon} alt={linkLabel === "Microsoft Visual Code Marketplace" ? "Logo Microsoft Visual Studio Code" : `Icon for ${linkLabel}`} className="link-platform-icon" style={{ marginRight: '8px', height: '20px' }} />
                                        <span style={{ marginRight: '8px' }}>{linkLabel}</span>
                                    </div>
                                    <a
                                        href={linkData.download_link}
                                        className="download-button icon-button"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        title={linkLabel}
                                        aria-label={linkLabel === "Microsoft Visual Code Marketplace" ? "Button with link icon directing users to AVAP extensions at Microsoft Visual Studio Code." : `Link to ${linkLabel}`}
                                    >
                                        <img src={icn_link} alt="Link Icon" className="button-icon" />
                                    </a>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const Workshop = () => {

    // State for copy feedback (optional)
    const [copiedCommandIndex, setCopiedCommandIndex] = React.useState<number | null>(null);

    // Docker commands data
    const dockerCommands = [
        {
            title: "AVAP Language",
            logo: logo_lang,
            command: "docker pull avapframework/avap-language-server:latest"
        },
        {
            title: "AVAP Virtual Server",
            logo: logo_vs,
            command: "docker pull avapframework/avap-virtual-server:latest"
        },
        {
            title: "AVAP Gateway",
            logo: logo_gateway,
            command: "docker pull avapframework/avap-gateway-advanced:latest"
        }
    ];

    // Function to handle copying command
    const handleCopyCommand = (command: string, index: number) => {
        navigator.clipboard.writeText(command).then(() => {
            setCopiedCommandIndex(index); // Indicate which command was copied
            setTimeout(() => setCopiedCommandIndex(null), 2000); // Reset after 2 seconds
        }).catch(err => {
            console.error('Failed to copy command: ', err);
            // Optionally show an error message to the user
        });
    };

    useEffect(() => {

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true) {
            ReactGA.initialize('G-MQZQJN7TQL');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: 'Avap Framework Downloads' });
        }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);

        // clean favicon 
        return () => {
            document.head.removeChild(link);
        };
    }, []);

    useEffect(() => {
        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };
    }, []);

    return (
        <>
            <FlNav />

            {/* Contenedor principal */}
            <div id="downloads" className='fl-cloud-product' style={{ backgroundImage: `url(${bg_pricing} )`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>

            <div style={{width:'100%', marginLeft:'auto', marginRight:'auto', textAlign:'center'}}>
            <img src={softtek} alt="" style={{textAlign:'center', width:'20%', marginTop:'9em'}} />
            </div>

                {/* Encabezado */}
                <div className="w-100 workshopHeader text-center mb-5 noGradient">
                    <div className="fl-title">Requirements for your Workshop</div>
                    <p className="mt-4 " style={{ maxWidth: '1000px', margin: '0 auto', marginBottom:'101px' }}>
                        Congratulations!!! You are about to participate in one of the AVAP Framework workshops.
                        To make the most of the workshop, we share the prerequisites and some recommendations
                        that will help you get the most out of the event.
                    </p>
                </div>

                <div className="container margin-neg-top">
                    <div className="workshop-requirements">
                        <ol className="requirements-list">
                            <div>
                                <h3>1. Attendees must be registered with <a href="https://avapid.com/Register" target="_blank" rel="noopener noreferrer" className="register-button">AVAP ID.</a></h3>
                            </div>
                            <div>
                                <h3>2. The workshop will include practical examples that require the following software:</h3>
                                <ul style={{marginLeft:'70px'}}>
                                    <li>
                                        <a href="https://code.visualstudio.com/download" target="_blank" rel="noopener noreferrer">
                                            Microsoft Visual Studio Code
                                        </a>
                                    </li>
                                    <li>
                                       
                                        <a href="https://marketplace.visualstudio.com/search?term=avap&target=VSCode&category=All%20categories&sortBy=Relevance"
                                            target="_blank" rel="noopener noreferrer" className="">
                                                MVSC extensiones AVAP
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.docker.com/products/docker-desktop/" target="_blank" rel="noopener noreferrer">
                                            Docker Desktop
                                        </a>
                                    </li>
                                    <li>
                                        Docker images for AVAP Language Server and AVAP Virtual Server.
                                        <div className="docker-commands mt-3">
                                            {dockerCommands.slice(0, 2).map((item, index) => (
                                                <div key={index} className="docker-command-card mb-3">
                                                    <img src={item.logo} alt={`Logo ${item.title}`} className="docker-card-logo" style={{ height: '40px', marginBottom: '15px' }} />
                                                    <div className="command-line-container" style={{ position: 'relative' }}>
                                                        <pre><code>{item.command}</code></pre>
                                                        <FontAwesomeIcon
                                                            icon={faCopy}
                                                            className="copy-icon"
                                                            onClick={() => handleCopyCommand(item.command, index)}
                                                            title={copiedCommandIndex === index ? 'Copied!' : 'Copy command'}
                                                            aria-label={`Button with copy icon to download ${item.title} command`}
                                                            role="button"
                                                            tabIndex={0}
                                                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleCopyCommand(item.command, index); }}
                                                            style={{
                                                                position: 'absolute',
                                                                top: '10px',
                                                                right: '10px',
                                                                cursor: 'pointer',
                                                                color: copiedCommandIndex === index ? 'var(--primary)' : 'inherit'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div>
                                <h3>3. Internet access is required.</h3>
                            </div>
                            <div>
                                <h3>4. Using firewalls, proxies, or VPNs can cause connectivity issues.</h3>
                            </div>
                        </ol>

                        <div className="support-info mt-5 text-center">
                            <p className="mt-4" style={{ maxWidth: '800px', margin: '0 auto' }}>
                                We've made the support center available to attendees so they can request any assistance they need.
                                If you require assistance, please email <a href="mailto:support@101obex.com">support@101obex.com</a>.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <FlFooter />
        </>
    );
};

export default Workshop;
